//@flow
import React, { useState } from 'react';
import type { JobPost } from 'types/careers';
import Slider from 'react-slick';
import { JobPostGrid } from 'components/molecules/jobPostGrid';
import { PaginationControl } from 'components/molecules/paginationControl';
import { useViewport } from 'components/templates/viewportProvider';
import { CardMetaInfo } from 'components/atoms/cardMetaInfo';
import { CardView } from 'components/molecules/card';
import './styles.scss';

type Props = {
  jobPosts: Array<JobPost>,
  onClick: () => void,
};

export const JobPosts = (props: Props) => {
  const { jobPosts, onClick } = props;
  const { height } = useViewport();
  const [activeSlide, setActiveSlide] = useState(0);
  const [slider, setSlider] = useState();
  const settings = {
    className: 'slider',
    infinite: false,
    slidesToShow: 1.04,
    slidesToScroll: 1,
    variableWidth: true,
    speed: 1000,
    beforeChange: (current, next) => setActiveSlide(next),
    arrows: false,
    draggable: true,
    rows: 2,
    slidesPerRow: 3,
    centerMode: false,
    centerPadding: '0px',
    cssEase: 'cubic-bezier(0.77, 0, 0.175, 1)',
  };

  const renderContent = () => {
    return (
      <>
        <div className={'job-posts-heading'}>
          <h3>Join Our Team</h3>
        </div>
        <div className={'job-posts-grid'}>
          <Slider
            ref={c => setSlider(c)}
            {...settings}
            style={{ height: '100%' }}
          >
            {jobPosts.map((job, idx) => (
              <JobPostGrid key={idx} data={job} onClick={onClick} />
            ))}
          </Slider>
        </div>
      </>
    );
  };
  const paginationLength =
    jobPosts.length && jobPosts.length > 6 ? Math.ceil(jobPosts.length / 6) : 1;

  // Render footer
  const next = () => {
    slider.slickNext();
  };

  const previous = () => {
    slider.slickPrev();
  };

  const renderFooter = () => {
    return (
      <div className="section-footer">
        <PaginationControl
          className={'section-footer-item'}
          theme={'dark-theme'}
          mode={'slider'}
          currentIndex={activeSlide + 1}
          total={paginationLength}
          onNextClick={next}
          onPreviousClick={previous}
        />
      </div>
    );
  };

  return (
    <div
      className={'section-container no-gutter job-posts-container'}
      style={{ height }}
    >
      {renderContent()}
      {renderFooter()}
    </div>
  );
};
